import { MutableRefObject, useEffect } from "react";

/** Maximum height (px) the auto-growing message textarea expands to before scrolling; matches the 8rem CSS cap. */
const TEXTAREA_MAX_HEIGHT = 128;

/** Grows the textarea to fit its content up to {@link TEXTAREA_MAX_HEIGHT}, then lets it scroll. */
export const useAutoGrowTextarea = (textareaRef: MutableRefObject<HTMLTextAreaElement | null>, value: string) => {
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    /* Reset height so the box can shrink, then grow to fit the text. */
    textarea.style.height = "auto";
    textarea.style.height = `${Math.min(textarea.scrollHeight, TEXTAREA_MAX_HEIGHT)}px`;
  }, [textareaRef, value]);
};
